module.exports = __webpack_public_path__ + "assets/img/index4_13.93171cf2.jpg";